import type { BrandCard, FileContext } from '../../services/work';

export interface BrandOption {
  readonly id: string;
  readonly name: string;
  readonly brand: BrandCard | null;
  readonly note?: string;
}

/** Keep choosing a brand distinct from following the project's default brand. */
export function brandChoices(context: FileContext, all: readonly BrandCard[] | null) {
  const known = new Map<string, BrandCard>();
  for (const brand of [...context.brands, ...(all ?? []), ...(context.brand ? [context.brand] : [])]) {
    const previous = known.get(brand.id);
    known.set(brand.id, { ...brand, logoUrl: brand.logoUrl ?? previous?.logoUrl ?? null });
  }
  const projectBrand = context.brands[0];
  const options: BrandOption[] = [
    ...(projectBrand ? [{ id: 'project', name: 'Use project brand', brand: known.get(projectBrand.id)!, note: `${projectBrand.name} · ${context.project?.name ?? 'Project default'}` }] : []),
    ...[...known.values()].map(brand => ({ id: brand.id, name: brand.name, brand })),
    { id: 'none', name: 'No brand', brand: null, note: 'Keep this file independent' },
  ];
  const now = context.brandChosen ? context.brand?.id ?? 'none' : projectBrand ? 'project' : context.brand?.id ?? 'none';
  return { options, now };
}
